<template>
    <div>
        <v-card>
            <v-toolbar outlined flat>
                <v-subheader class="title">{{status}} Devices Report</v-subheader>
                <v-spacer></v-spacer>
            </v-toolbar>
                <v-data-table
                    :headers="headers"
                    :items="data"
                    :items-per-page="15"
                    v-if="ready"
                >
                    <template v-slot:[`item.status`]="{ item }">
                        <v-chip
                            :color="getColorStatus(item.status)"
                            dark
                        >
                            {{ item.status }}
                        </v-chip>
                    </template>
                    <template v-slot:[`item.location`]="{ item }">
                        <div v-if="item.location != 'N/A'">
                            <a :href="item.location" target="_blank">{{ item.location }}</a>
                            <v-btn icon @click="copyLink(item.location)" class="pos mt-n7 mb-n2 ml-n5">
                                <v-icon small>
                                    mdi-content-copy
                                </v-icon>
                            </v-btn>
                        </div>
                        <div v-else>
                            <div>{{ item.location }}</div>
                        </div>
                    </template>
                </v-data-table>
                <v-row class="text-center align-center" v-else>
                    <v-col class="py-16">
                        <v-progress-circular
                            :indeterminate="true"
                            width="5"
                            size="50"
                            color="accent"
                        ></v-progress-circular>
                    </v-col>
                </v-row>
        </v-card>
        <v-snackbar v-model="show">
            Location copied to clipboard
            <template v-slot:action="{ attrs }">
                <v-btn
                color="pink"
                text
                v-bind="attrs"
                @click="show = false"
                > Close </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
export default {
    name: 'StatusCircuit',
    computed: {
        ...mapState({
            arrayON: state => state.meters.arrayON,
            arrayUP: state => state.meters.arrayUP,
            arrayDOWN: state => state.meters.arrayDOWN,
            arrayOFF: state => state.meters.arrayOFF,
            arrayOUT: state => state.meters.arrayOUT,
            records: (state) => state.meters.lastReadings,
            arrayMeterLinks: state => state.meters.arrayMeterLinks,
        })
    },
    data() {
        return {
            s: '',
            status: '',
            metersArray: [],
            headers: [],
            data: [],
            linksArray: [],
            datesArray: [],
            ready: false,
            i: 0,
            show: false,
        } 
    },
    methods: {
        setStatus(status){
            this.ready = false
            try {
                switch (status) {
                case 'on':
                    this.s = 'On'
                    this.status = 'On'
                    this.metersArray = this.arrayON
                    break;
                case 'off':
                    this.s = 'Off'
                    this.status = 'Off'
                    this.metersArray = this.arrayOFF
                    break;
                default:
                    this.s = 'Offline'
                    this.status = 'Offline'
                    this.metersArray = this.arrayOUT
                    break;
                }
                this.setDates()
                this.setParameters(this.arrayMeterLinks, this.datesArray)     
            } catch (error) {
                console.log(error)
            }
        },
        getColorStatus(status){
            if(this.metersArray[this.i] != undefined && this.i < this.metersArray.length){
                if(status === 'Offline') return 'red'
                else if (status === 'Off') return 'grey darken-3'
                else if (status === 'On') return 'green'
                else if (status === 'Underconsumption') return 'yellow darken-2'
                else if (status === 'Overconsumption') return 'orange darken-3'
            }
        },
        meterConsumption(array){
            if(array != undefined){
                let meter = array
                let foundMeter = this.records.find(m => m.meter === meter.name)
                let watts = foundMeter.lines.reduce((total, line) => total + line.watts, 0)
                let limOff = Number(this.metersArray[this.i].capacity);
                let limUp = Number(limOff + (limOff * 0.1))
                let limDown = Number(limOff - (limOff * 0.1))
                let limReg = Number(limOff - (limOff * 0.95))
                if(watts >= limReg && watts < limDown) return 'Underconsumption'
                else if(watts >= limDown && watts < limUp) return 'On'
                else if(watts >= limUp) return 'Overconsumption'
            }
        },
        setParameters(array1, array2){
            this.headers = [
                { text: 'Name', value: 'name' },
                { text: 'ID', value: 'id' },
                { text: 'Status', value: 'status' },
                { text: 'Last Read', value: 'date' },
                { text: 'Location', value: 'location' },
            ]
            this.data = this.metersArray.map( m => {
                let d = {}
                d.name = m.circuit
                d.id = m.gateway.id
                d.status = this.s
                
                if (d.status === 'On'){
                    let mOn = this.arrayON.find(r => r.circuit === m.circuit)
                    if (mOn != undefined) d.status = 'On'
                    let mUp = this.arrayUP.find(r => r.circuit === m.circuit)
                    if (mUp != undefined) d.status = 'Overconsumption'
                    let mDown = this.arrayDOWN.find(r => r.circuit === m.circuit)
                    if (mDown != undefined) d.status = 'Underconsumption'
                }
                
                let time = array2.findIndex(r => r.name === m.name)
                let hour = new Date(array2[time].date).toLocaleTimeString()
                let day = new Date(array2[time].date).getDate()
                let year = new Date(array2[time].date).getFullYear()
                let month = new Date(array2[time].date).getMonth() + 1
                let date = moment(array2[time].date).format('L')
                d.date = date + ' ' + hour
                d.location = 'N/A'
                let loc = array1.findIndex(l =>
                    l.name === m.circuit
                )
                if(array1[loc].url != 'N/A') {
                    d.location = array1[loc].url
                } else {
                    d.location = 'N/A'
                }
                return d
            } )
            this.ready = true
        },
        setDates(){
            let time = this.records.map(r => {
                if (r != undefined) {
                    let obj = {
                        name: r.meter,
                        date: r.timestamp
                    }
                    this.datesArray.push(obj)
                }
            })
        },
        copyLink(link){
            this.show = true
            navigator.clipboard.writeText(link)
        }
    },
    created(){
        this.setStatus(this.$route.params.id)
    },
}
</script>

<style scoped>
.title{
    text-transform: uppercase;
    padding: 0px;
    font-size: 0.9rem !important;
    font-weight: bold;
}
.link{
    text-decoration: underline;
}
.main{
    position: relative
}
.pos{
    position: relative;
    right: -400px;
    display: block;
}
</style>